(function () {
    'use strict';

    angular.module("imApp").factory("stockTransferService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1035,
                    parameters: parms || {}
                });
            },
            listLoaded: function (parms) {
                let method = 1055;
                if (parms?.stocktransfertype_keyno === '10') method = 1037;
                return $ihttp.post({
                    method: method,
                    parameters: parms || {}
                });
            },
            listUnloaded: function (parms) {
                return $ihttp.post({
                    method: 1042,
                    parameters: parms || {}
                });
            },
            listPlaced: function (parms) {
                return $ihttp.post({
                    method: 1047,
                    parameters: parms || {}
                });
            },
            pickFinishedObj: function (menu) {
                return $ihttp.post({
                    method: 1040,
                    parameters: menu
                });
            },
            unloadFinishedObj: function (menu) {
                return $ihttp.post({
                    method: 1063,
                    parameters: menu
                });
            },
            unloadAllObj: function (menu) {
                return $ihttp.post({
                    method: 1064,
                    parameters: menu
                });
            },
            printLabelTrolley: function (menu) {
                return $ihttp.post({
                    method: 3146,
                    parameters: menu
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 2178,
                    parameters: menu
                });
            },
            getP2PortalUserVariableSetWs: function (variablename, variablevalue) {
                return $ihttp.post({
                    method: 616,
                    parameters: {
                        variablename,
                        variablevalue
                    }
                });
            },
        };

        return service;
    }]);
})();
